import { render, staticRenderFns } from "./JonderTitle.vue?vue&type=template&id=4875390c&scoped=true&"
var script = {}
import style0 from "./JonderTitle.vue?vue&type=style&index=0&id=4875390c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875390c",
  null
  
)

export default component.exports